<template>
  <modal
    :background-mode="!adaptive.isMobile"
    :visible="visible"
    @on-close="close"
  >
    <div :class="['modal-confirm', { 'modal-confirm-rich': !!showIcon }]">
      <div v-if="showIcon" class="modal-confirm-icon">
        <f-sprite-icon :icon-link="icon" />
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="title" class="modal-confirm-title" v-html="sanitize(title)" />
      <div v-if="subtitle" class="modal-confirm-subtitle" v-html="sanitize(subtitle)" />
      <!-- eslint-enable vue/no-v-html -->
      <div v-if="buttons.length" class="modal-confirm-buttons">
        <ui-button
          v-for="(b, i) in buttons"
          :key="i"
          :text="b.text"
          :flat="!!b.flat"
          :secondary="!!b.secondary"
          @click="buttonClick(b.action)"
        />
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { sanitize } from '@/utils/sanitize';
import getErrorNotification from '@/utils/store/get-error-notification';

import IconInfo from '../../../assets/images/info.multi.svg';

export default defineComponent({
  name: 'Modal-confirm',

  inject: ['adaptive'],

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: IconInfo.id,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: [
    'on-close',
  ],

  setup() {
    return {
      sanitize,
    };
  },

  methods: {
    buttonClick(cb) {
      if (typeof cb === 'function') {
        const result = cb();
        if (typeof result?.catch === 'function') {
          result.catch((e) => {
            this.$store.dispatch(...getErrorNotification(e));
          });
        }
      }
      this.close();
    },
    close() {
      this.$emit('on-close');
    },
  },
});
</script>

<style lang="scss">
.modal-confirm {
  &-icon {
    width: 64px;
    height: 64px;
    margin: 16px auto;
  }
  &-title {
    padding-right: 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  &-subtitle {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
  }
  &-buttons {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    width: 100%;

    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    > *:not(:first-child) {
      margin-top: 12px;
    }
  }
  &-rich {
    text-align: center;
  }
}

@include breakpoint("tablet") {
  .modal-confirm {
    min-width: 200px;
    max-width: 440px;
    &-buttons {
      flex-direction: row;

      // TODO: Исправить на использование БЭМ-селекторов
      // stylelint-disable-next-line selector-max-universal
      > *:not(:first-child) {
        margin: 0 0 0 12px;
      }
    }
    &-rich {
      .buttons {
        justify-content: center;
      }
    }
  }
}
</style>
